// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeLeagueListBody = {
  sportId?: string | null;
};

export type typeLeagueListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagues: {
      leagueId: string;
      sportId: string;
      sportKey: string;
      leagueKey: string;
      name: string;
      shortName: string;
      abbreviation: string;
      displayOrder: number;
      isManuallyScored: boolean;
      primaryColorHex?: string | null;
      currentLeagueSeasonId?: string | null;
      standingsGroupings: { key: string; label: string }[];
      visibilityState: "hidden" | "comingSoon" | "live";
      isPoolEligible: boolean;
      hasStandings: boolean;
      logoUrl?: string | null;
    }[];
  };
};

export type typeLeagueListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaLeagueListBody = {
  type: "object",
  properties: {
    sportId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createLeagueList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaLeagueListBody);
  }

  return async function postLeagueList(
    payload: typeLeagueListBody,
  ): Promise<typeLeagueListOutput200 | typeLeagueListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postLeagueList" failed before calling the network. #973934186209`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#973934186209" },
        },
        data: null,
      } as typeLeagueListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/league/list`,
      httpMethod: "POST",
      options,
    })) as typeLeagueListOutput200 | typeLeagueListOutput400;
  };
}
